import * as React from 'react';
import { IStylingFirm } from '../Entities';
import { FormGroup, FormControl, ControlLabel, HelpBlock } from 'react-bootstrap';
import FormSelect from '../../../components/common/FormSelect';
import { Translate } from '../../../shared/LanguageService';
import FormValidationService from '../../../shared/form/FormValidationService';

interface IStylingFirmsFormProps {
    stylingFirm: IStylingFirm;
    onChange: (value: any) => void;
    errors: any;
}

const StylingFirmsForm = (props: IStylingFirmsFormProps) => {
    return (
        <FormGroup
            className="required"
            validationState={FormValidationService.getValidationState(props.errors.name)}
        >
            <ControlLabel>{Translate('styling-firms/modal/form/input-label/name')}</ControlLabel>
            <FormControl
                type="text"
                name="name"
                onChange={props.onChange}
                value={props.stylingFirm.name ? props.stylingFirm.name : ''}
            />
            {props.errors && <HelpBlock>{props.errors.name}</HelpBlock>}
        </FormGroup>
    );
};

export default StylingFirmsForm;
